'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import Image from 'next/image';
import { Button } from '@src/components/Button/Button';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { Stamp } from '@src/components/TopNavV3/Stamp';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { configPublic } from '@src/config.public';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
import type { TopNavItem } from '../TopNavProps';
const itemClasses = 'flex items-center gap-2 px-4 block cursor-pointer h-full transition-all hover:text-bodi-white';
const hoverTimeouts: Record<string, number> = {};
const hoverDelay = configPublic.general.topNavDelay;
export const TopNavDesktopBar = () => {
  const $ = _c(45);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    logo,
    items,
    logInCta,
    signUpCta,
    isExpanded,
    expandedMenu,
    setExpandedMenu,
    setExpanded
  } = useTopNav();
  let t0;
  if ($[0] !== expandedMenu?.title || $[1] !== isExpanded || $[2] !== setExpanded || $[3] !== setExpandedMenu || $[4] !== trackSelectNavCta) {
    t0 = items_0 => items_0?.filter(_temp).map((item_0, index) => {
      const isSelected = item_0.title === expandedMenu?.title && isExpanded;
      const componentKey = String(item_0.title);
      if (!item_0?.hasSubItems) {
        return <LocalizedLink onMouseEnter={() => setExpanded(false)} onClick={() => {
          trackSelectNavCta({
            "cta url": item_0.href
          });
        }} key={componentKey} className={itemClasses} href={item_0.href ?? ""} rel={item_0.newTab ? "noopener noreferrer" : ""} target={item_0.newTab ? "_blank" : "_self"}>{item_0.title}<Stamp text={item_0.stamp} /></LocalizedLink>;
      }
      return <button data-testid={`nav-item-${index}`} key={componentKey} onMouseEnter={() => {
        setExpandedMenu(item_0);
        hoverTimeouts[componentKey] = window.setTimeout(() => setExpanded(true), hoverDelay);
      }} onMouseLeave={() => {
        clearTimeout(hoverTimeouts[componentKey]);
      }} onClick={() => {
        clearTimeout(hoverTimeouts[componentKey]);
        setExpanded(!isExpanded);
      }} className={cn(itemClasses, "relative flex appearance-none items-center gap-2", {
        "text-bodi-white": isSelected
      })}>{item_0.title}<Stamp text={item_0.stamp} /><ChevronDownIcon className={cn("size-5 transition-all", {
          "rotate-180": isSelected
        })} /></button>;
    });
    $[0] = expandedMenu?.title;
    $[1] = isExpanded;
    $[2] = setExpanded;
    $[3] = setExpandedMenu;
    $[4] = trackSelectNavCta;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const renderItems = t0;
  let t1;
  if ($[6] !== logo || $[7] !== setExpanded || $[8] !== trackSelectNavCta) {
    t1 = logo?.src && <LocalizedLink onMouseEnter={() => setExpanded(false)} onClick={() => {
      trackSelectNavCta({
        "cta url": logo?.href
      });
    }} href={logo?.href ?? ""} className="flex h-full items-center pr-4"><Image src={logo.src} width={logo?.desktopWidth} height={logo?.desktopHeight} alt={logo?.altText ?? ""} /></LocalizedLink>;
    $[6] = logo;
    $[7] = setExpanded;
    $[8] = trackSelectNavCta;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== items || $[11] !== renderItems) {
    t2 = renderItems(items);
    $[10] = items;
    $[11] = renderItems;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t1 || $[14] !== t2) {
    t3 = <div className="flex h-full items-center">{t1}{t2}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== setExpanded) {
    t4 = () => setExpanded(false);
    $[16] = setExpanded;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== logInCta?.href || $[19] !== trackSelectNavCta) {
    t5 = () => {
      trackSelectNavCta({
        "cta url": logInCta?.href
      });
    };
    $[18] = logInCta?.href;
    $[19] = trackSelectNavCta;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const t6 = logInCta?.href ?? "";
  const t7 = logInCta?.newTab ? "noopener noreferrer" : "";
  const t8 = logInCta?.newTab ? "_blank" : "_self";
  const t9 = logInCta?.title;
  let t10;
  if ($[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <LocalizedLink onClick={t5} data-testid="logInBtn" href={t6} className="flex cursor-pointer gap-2 hover:text-bodi-white" rel={t7} target={t8}>{t9}</LocalizedLink>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== signUpCta?.href || $[28] !== trackSelectNavCta) {
    t11 = () => {
      trackSelectNavCta({
        "cta url": signUpCta?.href
      });
    };
    $[27] = signUpCta?.href;
    $[28] = trackSelectNavCta;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = signUpCta?.href ?? "";
  const t13 = signUpCta?.newTab ? "noopener noreferrer" : "";
  const t14 = signUpCta?.newTab ? "_blank" : "_self";
  const t15 = signUpCta?.title;
  let t16;
  if ($[30] !== t15) {
    t16 = <Button className="[&>div]:px-8" size="small">{t15}</Button>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t14 || $[36] !== t16) {
    t17 = <LocalizedLink onClick={t11} data-testid="signUpBtn" href={t12} rel={t13} target={t14}>{t16}</LocalizedLink>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t10 || $[39] !== t17 || $[40] !== t4) {
    t18 = <div onMouseEnter={t4} className="ml-auto flex h-full flex-1 items-center justify-end gap-8">{t10}{t17}</div>;
    $[38] = t10;
    $[39] = t17;
    $[40] = t4;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t18 || $[43] !== t3) {
    t19 = <div className="relative z-50 h-20 w-full bg-bodi-black-text font-medium text-bodi-gray-butters"><Container className="h-full *:h-full"><div className="flex h-full items-center">{t3}{t18}</div></Container></div>;
    $[42] = t18;
    $[43] = t3;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};
function _temp(item) {
  return Boolean(item.title);
}